<template>
    <v-dialog v-model="showCriterio" persistent>
        <v-toolbar class="custom-font-regular requerimiento-toolbar" color="#dedfe4">
            <v-toolbar-title>Nueva Entrada</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items right>
                <v-btn icon @click="hideDialog" :disabled="saving" right><v-icon>close</v-icon></v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card color="#eaeaea" class="criterio-content">
            <CriterioDetail :criterio="criterio" :is-ficha="true" :draft="false"
                            @updateRequerimiento="updateAfterRequest"></CriterioDetail>
            <v-card-actions class="buttons-content">
                <v-spacer></v-spacer>
                <v-btn color="#1787c9" class="submit-button white--text"
                       v-if="!isUpdatingCriterioInDraft"
                       :disabled="!canSubmit || saving"
                       @click="submitRepo">Presentar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CriterioDetail from '../../presentacion/components/CriterioDetailTreeView'

export default {
  props: {
    criterio: Object,
    isUpdatingCriterioInDraft: Boolean
  },

  components: {
    CriterioDetail
  },

  data () {
    return {
      showCriterio: true,
      saving: false,
      updatedRequerimientosId: [],
      submitPath: 'draft/repo/add'
    }
  },

  computed: {
    canSubmit () {
      return this.criterio.requerimientos.length === this.updatedRequerimientosId.length
    }
  },
  methods: {
    submitRepo () {
      this.saving = true
      this.axios
        .put(`${this.submitPath}/${this.criterio.pk}`)
        .then((response) => {
          this.$emit('updateRequerimiento', response)
          this.updatedRequerimientosId = []
          this.$emit('hideDialog', true)
          this.saving = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    hideDialog () {
      this.saving = true
      this.$emit('hideDialog', this.isUpdatingCriterioInDraft)
    },
    updateAfterRequest (updatedRequerimiento) {
      for (let index in this.criterio.requerimientos) {
        const requerimiento = this.criterio.requerimientos[index]
        if (requerimiento.pk === updatedRequerimiento.data.pk) {
          this.$set(this.criterio.requerimientos, index, updatedRequerimiento.data)
          this.$set(this.criterio, 'estadoDisplay', updatedRequerimiento.data.criterio.estado)
          if (!this.updatedRequerimientosId.includes(requerimiento.pk)) {
            this.updatedRequerimientosId.push(requerimiento.pk)
          }
          break
        }
      }
    }
  }
}
</script>

<style scoped>
  .custom-font-regular {
      font-family: SourceSansProRegular, sans-serif;
  }
  .submit-button {
      padding: 0 3em 0 3em;
  }
</style>
